import React from 'react';

import Icons from 'components/icons/Icons';
import I18n from 'components/translate/I18n';
import PropTypes from 'prop-types';

const ConfirmationModalInfo = ({ icon, label, children }) => (
  <div className="config-streaming-confirmation-modal__body__info">
    <Icons
      prefix="far"
      iconName={icon}
      className="config-streaming-confirmation-modal__body__info__icon"
    />
    <span>
      <I18n html label={label} />
      {children}
    </span>
  </div>
);

ConfirmationModalInfo.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
};

export default ConfirmationModalInfo;
